import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import { Link } from "react-router-dom";
import { getCurrentSite } from "../../../state/user";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  z-index: 1;
  background-color: ${props => props.theme.color1};
  color: ${props => props.theme.color2};
  h2 {
    border-bottom: 1px solid ${props => props.theme.color3};
    font-weight: 700;
    font-size: 18px;
    padding: 20px;
    margin: 0px;
  }
`;

const Content = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  li {
    color: ${props => props.theme.color2};
  }
`;

const MenuButton = styled.button`
  padding: 10px 20px;
  width: 100%;
  color: ${props => props.theme.color2};
  background-color: ${props =>
    props.selected ? props.theme.menuColor : "transparent"};
  cursor: pointer;
  border: 0px solid;
  height: 52px;
  font-weight: 400;
  font-size: 18px;
  text-align: left;
  min-width: 250px;
  outline: none;
`;

export default withTheme(props => {
  const { theme, selected } = props;
  const { clicked, setClicked } = useState(false);
  return (
    <Root clicked={clicked} data-id="root-menu">
      <h2>{getCurrentSite()}</h2>
      <Content>
        <li>
          <Link to="/company">
            <MenuButton selected={selected === "company"}>Company</MenuButton>
          </Link>
        </li>
        {/* <li>
          <Link to="/locations">
            <MenuButton selected={selected === "locations"}>
              Locations
            </MenuButton>
          </Link>
        </li> */}
        <li>
          <Link to="/lessons">
            <MenuButton selected={selected === "lesson"}>Lessons</MenuButton>
          </Link>
        </li>
        <li>
          <Link to="/schedule">
            <MenuButton selected={selected === "schedule"}>Schedule</MenuButton>
          </Link>
        </li>
        <li>
          <Link to="/bookings">
            <MenuButton selected={selected === "booking"}>Bookings</MenuButton>
          </Link>
        </li>
        <li>
          <Link to="/publish">
            <MenuButton selected={selected === "publish"}>Publish</MenuButton>
          </Link>
        </li>
        {/* <li>
          <Link to="/analytics">
            <MenuButton selected={selected === "statistic"}>
              Statistics
            </MenuButton>
          </Link>
        </li> */}
        <li>
          <Link to="/posts">
            <MenuButton selected={selected === "post"}>Posts</MenuButton>
          </Link>
        </li>
      </Content>
    </Root>
  );
});
